import React from 'react';
import RaportsContainer from '../../elements/e-commerce/Raports/RaportsContainer';

const Raports = () => {
  return <RaportsContainer />;
};

export default Raports;
